import React from "react";
import { useSearchParams } from "react-router-dom";
import { Lst } from "./List/Lst";
import Label from "./Label";
//import Header from "./Components/Header";

//src\Components\List\FungicideList.js
function QR() {
  const [params] = useSearchParams();
  const itemcode = params.get("product");
  const mfg = params.get("mfg");
  const exp = params.get("exp");
  const batch = params.get("Batch");
  console.log("pahle");
  console.log(itemcode + "Hi");
  //console.log({ itemcode.Name } + "Hi");
  console.log("baad");
  console.log("Insecticides:", Lst);

  const item = Lst.find((p) => p.Name.toLowerCase() === itemcode.toLowerCase());
  console.log(item);
  const imgUrl = item.imgurl;
  console.log(imgUrl);
  return (
    <div>
      <p>
        <b>Product:</b>
        <b>mfg:</b> {params.get("mfg")}
        <b>item:</b> {item.Name}
        <img src={imgUrl} alt="" style={{ width: "250px" }} />
        <Label item={item} mfg={mfg} exp={exp} batch={batch}></Label>
      </p>
    </div>
  );
}

export default QR;
